/* Heartwood Toys — small storefront helpers */
(function () {
  var HEADER_OFFSET = 0; // extra breathing room below the sticky header

  // Only the header itself is sticky (the announcement bar scrolls away). Measure it
  // directly: the theme's --header-height variable can run a little high.
  function headerHeight() {
    var header = document.querySelector('header-component');
    if (header) {
      var h = header.getBoundingClientRect().height;
      if (h > 0) return h;
    }
    var v = getComputedStyle(document.body).getPropertyValue('--header-height') || '';
    var n = parseFloat(v);
    return isNaN(n) ? 66 : n;
  }

  // Animated scroll that doesn't rely on CSS scroll-behavior (which the theme's
  // scroll handling can interrupt).
  function animateScrollTo(getTargetY, duration) {
    var startY = window.scrollY || window.pageYOffset;
    var html = document.documentElement;
    function endY() {
      var maxY = Math.max(0, html.scrollHeight - window.innerHeight);
      return Math.min(Math.max(0, getTargetY()), maxY);
    }
    if (Math.abs(endY() - startY) < 2) return;
    var previousBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    var start = performance.now();
    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
    function step() {
      var t = Math.min(1, (performance.now() - start) / duration);
      // Re-read the destination every frame so lazy-loaded images above the target
      // (which change the page height mid-scroll) don't leave us short.
      window.scrollTo(0, startY + (endY() - startY) * easeOutCubic(t));
      if (t < 1) {
        // setTimeout rather than requestAnimationFrame so the scroll still completes
        // if the tab is briefly hidden (rAF pauses in background tabs).
        window.setTimeout(step, 16);
      } else {
        // Settle: the sticky header shrinks once scrolling starts, so re-check the
        // destination after layout has caught up and nudge if we're off.
        window.setTimeout(function () {
          var y = endY();
          if (Math.abs(y - (window.scrollY || window.pageYOffset)) > 1) window.scrollTo(0, y);
          html.style.scrollBehavior = previousBehavior;
        }, 60);
      }
    }
    step();
  }

  function scrollToHash(hash) {
    if (!hash || hash.length < 2) return false;
    var el = document.getElementById(hash.slice(1));
    if (!el) return false;
    // Invisible anchor markers (e.g. #whats-inside) stand in for their whole section:
    // land on the section's top edge rather than the marker itself.
    var target = el;
    var sectionEl = el.closest('.shopify-section');
    if (sectionEl && el.getBoundingClientRect().height <= 2) target = sectionEl;
    animateScrollTo(function () {
      return target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - headerHeight() - HEADER_OFFSET;
    }, 650);
    return true;
  }

  // Same-page anchor links (e.g. "See what's inside"). The theme's page-transition
  // router can swallow these, so we handle them first (window, capture phase).
  window.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href*="#"]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      var path = href.slice(0, hashIndex);
      var hash = href.slice(hashIndex);
      var samePage = path === '' || path === '/' || path === window.location.pathname;
      if (!samePage) return;
      if (!document.getElementById(hash.slice(1))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToHash(hash);
      if (history.replaceState) history.replaceState(null, '', hash);
    },
    true
  );

  // Fallback: if something else changes the hash without scrolling, scroll.
  window.addEventListener('hashchange', function () {
    scrollToHash(window.location.hash);
  });

  // Landing on a URL with a hash: nudge to it once layout settles.
  if (window.location.hash) {
    window.setTimeout(function () {
      scrollToHash(window.location.hash);
    }, 350);
  }
})();
